import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Make sure axios is already installed or use your preferred method for HTTP requests

export default function PaymentHome() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
      try {
        const response = await axios.get(GET_USER,
          config, 
        {
          withCredentials: true,
        });

        const userId = response.data?.user?._id; // Access user ID from the response
        const selectedPlan = sessionStorage.getItem("selectedPlan"); // Get selected plan from local storage
       
        if (userId && selectedPlan) {
            console.log(response.data);
            navigate("/paymentproceed"); // User has both userId and selected plan
          } else if (!selectedPlan) {
            navigate("/plans"); // User signed up without selecting a plan
          } else {
            navigate("/"); // User does not have a selected plan or userId
          }
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/paymentplan");
      }
    };

    fetchUserData();
  }, [navigate]);

  return <div></div>;
}